import simpleFetch from "../../../utils/simpleFetch";
import { FR, EN } from "../../components/common/enums/languages";

export default class AttributeApi {
    static getEnum(name, query) {
        return simpleFetch("get", `/v1/${name}?${query || ""}`, {
            headers: { "Accept-Language": `${FR.value},${EN.value}` },
        });
    }
}



// WEBPACK FOOTER //
// ./src/utils/enums/enumApi.js